/* unplugin-vue-components disabled */const { computed } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-016b65d6"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "tcp-panel-wrap" };
const work_1 = require("@/store/modules/work");
const model_1 = require("@/model");
const UcsPanel_vue_1 = tslib_1.__importDefault(require("@/views/design/components/UcsPanel.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'TcpPanel',
    props: {
        machine: {
            type: model_1.Robot,
            required: true,
        }
    },
    setup(__props) {
        const store = (0, work_1.useWork)();
        const props = __props;
        function addTcp() {
            let tcp = props.machine.addTcp();
            store.selectNode(tcp);
        }
        const tcps = computed(() => props.machine.tcps.filter(e => e.reference.frame !== 'rp'));
        const handleDel = (id) => {
            props.machine.delTcp(id);
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(tcps), (tcp) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(UcsPanel_vue_1.default, {
                        key: tcp.id,
                        machine: tcp,
                        "is-read-only": tcp.isTcpOrigin,
                        "is-show-del-btn": !tcp.isTcpOrigin,
                        onDelConfirm: ($event) => (handleDel(tcp.id))
                    }, null, 8, ["machine", "is-read-only", "is-show-del-btn", "onDelConfirm"]));
                }), 128))
            ]));
        };
    }
});
